
import "babel-polyfill";

//Angular libs
import 'angular';
import 'angular-animate';
import 'angular-aria';
import 'angular-cookies';
import 'angular-messages';
import 'angular-resource';
import 'angular-sanitize';

//Angular translate
import 'angular-translate';
import 'angular-translate-loader-partial';
import 'angular-translate-storage-cookie';
import 'angular-translate-storage-local';
import 'angular-dynamic-locale';

//Angular router
import 'angular-ui-router';

//Angular ui boostrap
import 'angular-ui-bootstrap';

//Utilities
import  adler32cs from 'adler32cs';
window.adler32cs = adler32cs;

//Accounting
import accounting from 'accounting';
window.accounting = accounting;

//https://momentjs.com/docs/
import moment from 'moment';
window.moment = moment;

// https://lodash.com/docs/
import array from 'lodash/array';
window.array = array;

//Application files
import '../common/model/taric/geo-area-model.js';
import '../common/model/taric/measure-type-model.js';
import '../common/model/taric/menu-model.js';
import '../taric/quota/shared/taric-quota-model.js';
import '../taric/quota/taric-quota.js';
import '../taric/quota/search/quota-search.js';
import '../taric/quota/view/quota-view.js';
import '../common/popup/geo-area/geo-area-popup.js';
import '../common/filter/description-filter.js';
import '../common/popup/about/about-popup.js';
import '../taric/nomenclature/taric-nomenclature.js';
import '../taric/nomenclature/sbn/nomenclature-sbn.js';
import '../common/popup/measure/measure-popup.js';
import '../taric/measure/taric-measure.js';
import '../taric/measure/ccrm/measure-ccrm.js';
import '../taric/measure/shared/measure-model.js';
import '../common/popup/condition/condition-popup.js';
import '../common/popup/footnote/footnote-popup.js';
import '../common/popup/footnotes/footnotes-popup.js';
import '../common/model/taric/footnote-model.js';
import '../taric/adco/shared/additional-code-model.js';
import '../common/popup/additional-code/additional-code-popup.js';
import '../common/popup/additional-codes/additional-codes-popup.js';
import '../common/directive/country.directive.js';
import '../taric/moreinfo/links/links-model.js';
import '../taric/moreinfo/links/taric-links.js';
import '../taric/moreinfo/links/search/links-search.js';
import '../taric/nomenclature/shared/nomenclature-model.js';
import '../common/model/taric/language-model.js';
import '../common/filter/url-filter.js';
import '../common/filter/commoditycode-filter.js';
import '../common/helper/common-helper.js';
import '../common/config/config.js';
import '../common/filter/special-character-to-html-filter.js';
import '../common/filter/decimal-number-filter.js';
import '../common/filter/decimal-number-calc-result-filter.js';
import '../common/filter/measuretype-description-filter.js';
import '../common/filter/geographical-area-description-filter.js';
import '../common/filter/truncate-long-text-filter.js';
import '../common/filter/additional-code-filter.js';
import '../common/filter/footnote-filter.js';
import '../common/filter/certificate-filter.js';
import '../common/filter/duty-expression-description-filter.js';
import '../common/model/taric/monetary-units-model.js';
import '../common/directive/monetary-unit.directive.js';
import '../taric/duties/shared/calculate-duties-model.js';
import '../taric/duties/calculate/cd.js';
import '../taric/duties/calculate/data/cd.data.js';
import '../taric/duties/calculate/commodity/cd.commodity.js';
import '../taric/duties/calculate/units/cd.units.js';
import '../taric/duties/calculate/security/cd-security.js';
import '../taric/nomenclature/shared/gono-tree.directive.js';
import '../taric/duties/calculate/additional-codes/additional-codes.js';
import '../taric/duties/calculate/results/cd-results.js';
import '../taric/duties/calculate/documents/cd-documents.js';
import '../common/filter/decimal-number-exchangerates-result-filter.js';
import '../taric/duties/shared/exchange-rates-model.js';
import '../taric/duties/exchangerates/er-exchangerates.js';
import '../taric/adco/taric-adco.js';
import '../taric/adco/lookup/adco-lookup.js';
import '../taric/adco/view/adco-view.js';
import '../taric/adco/shared/adco-type-model.js';
import '../taric/footnote/taric-footnote.js';
import '../taric/footnote/lookup/footnote-lookup.js';
import '../taric/footnote/view/footnote-view.js';
import '../taric/certificate/taric-certificate.js';
import '../taric/certificate/lookup/certificate-lookup.js';
import '../taric/certificate/shared/certificate-model.js';
import '../taric/measure/mcc/measure-mcc.js';
import '../taric/nomenclature/ct/correlation-table-model.js';
import '../taric/nomenclature/ct/correlation-table-search.js';
import '../taric/report/taric-report.js';
import '../taric/report/pt/printed-taric-model.js';
import '../taric/report/pt/printed-taric-search.js';
import '../taric/report/relief/search/relief-code-search.js';
import '../taric/report/relief/shared/relief-code-model.js';
import '../taric/report/relief/view/relief-code-view.js';
import '../taric/report/mlr/mlr-model.js';
import '../taric/report/mlr/mlr-search.js';
import '../taric/report/measure/measure-report-search.js';
import '../taric/report/measure/measure-report-model.js';
import '../taric/report/measureamendments/measure-amendments-search.js';
import '../taric/report/measureamendments/measure-amendments-model.js';
import '../taric/duties/shared/meursing-model.js';
import '../taric/duties/meursing/meursing-search.js';
import '../taric/duties/taric-duties.js';
import '../taric/nomenclature/sbt/text-model.js';
import '../taric/nomenclature/sbt/text-search.js';
import '../taric/moreinfo/codelists/shared/codelists-model.js';
import '../taric/moreinfo/codelists/taric-codelists.js';
import '../taric/moreinfo/codelists/search/codelists-search.js';
import '../taric/moreinfo/codelists/view/codelists-view.js';
import '../taric/auth/model.js';
import '../taric/auth/login-helper.js';
import '../taric/auth/user-helper.js';
import '../home/home.js';
import '../news/news.js';
import '../news/news-model.js';
import '../about/about.js';
import '../about/about-model.js';
import '../callback/cb.js';

import '../css/bootstrap.min.css';
import '../css/font-awesome.min.css';
import '../css/arctic-tariff.css';
import '../css/taric-tree.css';
import '../css/customized-arctic-tariff.css';


var arcticTARIFF = angular.module('arctic.tariff', ['ui.router', 'ui.bootstrap', 'tmh.dynamicLocale', 'ngAria', 'taric.auth.loginhelper',
    'taric.auth.userhelper','taric.quota', 'taric.nomenclature', 'taric.measure', 'taric.moreinfo.links',
    'taric.duty', 'taric.adco', 'taric.footnote', 'taric.certificate', 'taric.report', 'taric.moreinfo.codelists',
    'common.config', 'ngCookies', 'ngSanitize', 'pascalprecht.translate', 'taric.model.menu',
    'arctic.tariff.home', 'arctic.tariff.news', 'arctic.tariff.about', 'common.template.about.popup', 'arctic.tariff.callback']);


arcticTARIFF.config(function ($stateProvider, $locationProvider, tmhDynamicLocaleProvider, $httpProvider) {
    $stateProvider
        .state('home', {
            url: "/home",
            templateUrl: 'home/home.html',
            controller : 'HomeController as homeCtrl',
            resolve: {
                loadTranslation: function ($translatePartialLoader) {
                    $translatePartialLoader.addPart('common');
                    $translatePartialLoader.addPart('home');
                },

                setupMenu: function (MenuModel) {
                    MenuModel.disablePrintable();
                    MenuModel.disableExportable();
                    MenuModel.setHelpIndex("");
                    MenuModel.notifyObservers();
                }
            }
        }).state('news', {
        url: "/news",
        templateUrl: 'news/news.html',
        controller : 'NewsController as newsCtrl',
        resolve: {
            loadTranslation: function ($translatePartialLoader) {
                $translatePartialLoader.addPart('common');
                $translatePartialLoader.addPart('news');
            },
            setupMenu: function (MenuModel) {
                MenuModel.disablePrintable();
                MenuModel.disableExportable();
                MenuModel.setHelpIndex("");
                MenuModel.notifyObservers();
            },
            defaultRssFeeds : function (NewsModel) {
                return NewsModel.getRssFeeds();
            }
        }
        })
        .state('about', {
            url: "/about",
            templateUrl: 'about/about.html',
            controller : 'AboutController as aboutCtrl',
            resolve: {
                loadTranslation: function ($translatePartialLoader) {
                    $translatePartialLoader.addPart('common');
                    $translatePartialLoader.addPart('about');
                },
                setupMenu: function (MenuModel) {
                    MenuModel.disablePrintable();
                    MenuModel.disableExportable();
                    MenuModel.setHelpIndex("");
                    MenuModel.notifyObservers();
                }
            }
        })
        .state('taric', {
            url: "/taric",
            templateUrl: 'taric/taricTemplate.html',
            resolve: {
                loadTranslation: function ($translatePartialLoader) {
                    $translatePartialLoader.addPart('common');
                }
            }
        })
        .state('cb', {
            url: "/cb",
            controller : 'CallbackController as callbackCtrl',
            templateUrl: 'callback/cb.html',
            resolve: {
                loadTranslation: function ($translatePartialLoader) {
                    $translatePartialLoader.addPart('common');
                },
                setupMenu: function (MenuModel) {
                    MenuModel.disablePrintable();
                    MenuModel.disableExportable();
                    MenuModel.setHelpIndex("");
                    MenuModel.notifyObservers();
                }
            }
        });
        
    $locationProvider.html5Mode(false).hashPrefix('!');

    // Configure path to angular locale files.
    tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-i18n/angular-locale_{{locale}}.js');

    //initialize get if not there
    if (!$httpProvider.defaults.headers.get) {
        $httpProvider.defaults.headers.get = {};
    }

    //disable ajax request caching -- ACSMNT-3843
    $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
    $httpProvider.defaults.headers.get.Pragma = 'no-cache';

});

arcticTARIFF.config(function($translateProvider, CONSTANTS) {
    $translateProvider.useLoader('$translatePartialLoader', {
        urlTemplate: 'i18n/{part}/{lang}.json'
    });
    // Enable escaping of HTML
    $translateProvider.useSanitizeValueStrategy('escape');
    var currentLanguage = localStorage.getItem('NG_TRANSLATE_LANG_KEY');    
    if (!currentLanguage) {
        currentLanguage = CONSTANTS.availableLanguages[0];
    }
    $translateProvider.preferredLanguage(currentLanguage).fallbackLanguage(['en']);
    // remember language
    $translateProvider.useLocalStorage();
});

arcticTARIFF.service('MetaDataInformationService', function (CONSTANTS, $translate, $state, $location, AboutModel) {
    var model = this;
    var metaData = null;
    model.reloadMetaDataInformation = function(){
        if (metaData){
            metaData.installationCountry = CONSTANTS.installationCountry;
            metaData.authority = CONSTANTS.authority;
            metaData.language  = $translate.use();
            metaData.identifier = $location.absUrl();
            var titleKey = 'i8n.common.arctic-tariff.title.' + $state.current.name;
            $translate(titleKey).then(function (pageTitle){
                metaData.title = pageTitle;
                metaData.desription = pageTitle;
                var index = pageTitle.indexOf('|');
                if (index > 0){
                    metaData.desription = pageTitle.substring(0, index).trim();
                }
            });

            $translate('metadata.DCTERMS.type').then(function (type){
                metaData.type = type;
            });

            AboutModel.getMetadata().then(function(result){
                metaData.buildDate = result.buildDate;
            }, function(error){
                //Do nothing if we can not load the meta data
            });
        }
    };

    model.init = function(){
        if (CONSTANTS.includeMetaData){
            metaData = {};
        }
        model.reloadMetaDataInformation();
    };

    model.getMetaDataInformation = function(){
        return metaData;
    };

    model.init();
});

arcticTARIFF.controller('MetaDataInformationCtrl', function($rootScope, CONSTANTS, MetaDataInformationService){
    var metaDataInfoCtrl = this;
    metaDataInfoCtrl.includeMetaData = CONSTANTS.includeMetaData;
    metaDataInfoCtrl.metaData = MetaDataInformationService.getMetaDataInformation();
});

arcticTARIFF.controller('BannerController', function($scope, $rootScope, $translate, $translatePartialLoader, CommonHelper, AuthorizeModel, CONSTANTS, $uibModal){
    $translatePartialLoader.addPart('common');
    var bannerCtrl = this;
    bannerCtrl.showApplicationTitle = CONSTANTS.showApplicationTitle;
    bannerCtrl.installationCountry = CONSTANTS.installationCountry;
    bannerCtrl.availableLanguages = CONSTANTS.availableLanguages;
    bannerCtrl.userName = AuthorizeModel.userName;
    bannerCtrl.changeLanguage = function (langKey) {
        $translate.use(langKey);
        // When changing language in Tariff GUI, we need to set used language to open ite-auth GUI later.
        CommonHelper.setCookie('language', langKey, 360);
    };
    $rootScope.$on('userName', function(event, data) {
        bannerCtrl.userName = AuthorizeModel.userName;
    });
    bannerCtrl.logoImagePath = CommonHelper.getLogoImagePath(true);
    bannerCtrl.currentLanguage = $translate.use();
    $rootScope.$on('$translateChangeSuccess', function () {
        bannerCtrl.logoImagePath = CommonHelper.getLogoImagePath(true);
        bannerCtrl.currentLanguage = $translate.use();
    });
    bannerCtrl.openAboutPopup = function (size) {
        $uibModal.open({
            animation: true,
            templateUrl: 'common/popup/about/about-popup.tmpl.html',
            controller: 'AboutPopupController as aboutPopupCtrl',
            size: size
        });
    };
});

arcticTARIFF.controller('MenuController', function(CONSTANTS, $rootScope, $scope, $translate, $state, LoginHelper, UserHelper, AuthorizeModel, MenuModel, $window, $location, $http){
    var menuCtrl = this;
    menuCtrl.model = AuthorizeModel;
    menuCtrl.menu = CONSTANTS.menu;

    menuCtrl.loggedIn = AuthorizeModel.loggedIn;
    menuCtrl.userName = AuthorizeModel.userName;

    if (CONSTANTS.credentialSetting === 'BASIC') {
        menuCtrl.showLogin = true;
    } else {
        menuCtrl.showLogin = false;
    }

    menuCtrl.helpLink = "";
    menuCtrl.toggleMenu = false;
    menuCtrl.exportable = false;
    menuCtrl.printable = false;

    menuCtrl.doLogin = function() {
        LoginHelper.goToLogin();
    };

    menuCtrl.doLogout = function() {
        AuthorizeModel.logout();
        $state.go(CONSTANTS.menu.landingPage);
        $rootScope.$broadcast('enableLogin');
        $rootScope.$broadcast('clearSearchResult');
        $rootScope.$broadcast('userName');
        if (CONSTANTS.credentialSetting === 'BASIC') {
            $http.post(`${CONSTANTS.auth_url}/logout`, null);
        }
    };

    menuCtrl.updateMenu = function(){

        menuCtrl.exportable = MenuModel.data().exportable;
        menuCtrl.printable = MenuModel.data().printable;

        var gAgent = navigator.userAgent.toLowerCase();
        var gbChrome=(gAgent.indexOf("chrome")!=-1);
        var gbSafari=(gAgent.indexOf("safari")!=-1);
        var gbFirefox=(gAgent.indexOf("firefox")!=-1);

        var nMapId = MenuModel.data().helpIndex;
        var strWnd = "";
        var url = CONSTANTS.helpServer;
        var language =  "/" + $translate.use() + "/";
        var pszHelpFile = "";

        if (nMapId) {

            if(navigator.userAgent.indexOf('MSIE')!==-1 || navigator.appVersion.indexOf('Trident/') > 0) {

                pszHelpFile = "#<id=" + nMapId;
            } else {

                pszHelpFile = "#%3Cid=" + nMapId;
            }
        }

        var firstSegment = url.substr(0, url.lastIndexOf('/'));
        var lastSegment = url.substr(url.lastIndexOf('/') + 1);

        if (!gbChrome && (gbSafari || gbFirefox))
            menuCtrl.helpLink = firstSegment + language + lastSegment;
        else
            menuCtrl.helpLink = firstSegment + language + lastSegment + pszHelpFile;
    };

    menuCtrl.print = function() {
        if (menuCtrl.printing) {
            return;
        }
        $rootScope.$broadcast('printDocument');
    };

    menuCtrl.export = function() {
        if (menuCtrl.exporting) {
            return;
        }
        $rootScope.$broadcast('exportDocument');
    };

    $rootScope.$on('startSpinningPrint', function(event, data) {

        menuCtrl.printing = true;
    });

    $rootScope.$on('stopSpinningPrint', function(event, data) {

        menuCtrl.printing = false;
    });

    $rootScope.$on('startSpinningExport', function(event, data) {

        menuCtrl.exporting = true;
    });

    $rootScope.$on('stopSpinningExport', function(event, data) {

        menuCtrl.exporting = false;
    });

    $rootScope.$on('disablePrintable', function(event, data) {
        MenuModel.disablePrintable();
        menuCtrl.printable = MenuModel.data().printable;
    });

    $rootScope.$on('enablePrintable', function(event, data) {
        MenuModel.enablePrintable();
        menuCtrl.printable = MenuModel.data().printable;
    });

    $rootScope.$on('disableExportable', function(event, data) {
        MenuModel.disableExportable();
        menuCtrl.exportable = MenuModel.data().exportable;
    });

    $rootScope.$on('enableExportable', function(event, data) {
        MenuModel.enableExportable();
        menuCtrl.exportable = MenuModel.data().exportable;
    });

    $rootScope.$on('tokenInvalid', function(event, data) {
        AuthorizeModel.init();
        menuCtrl.loggedIn = AuthorizeModel.loggedIn;

        // Reset global authorization header
        LoginHelper.setAuthorizationHeader();

        // If SSO is enabled it should not be possible to login again if you logout. In that case the application will have to be restarted.
        if (CONSTANTS.credentialSetting === 'SSO') {
            menuCtrl.showLogin = false;
        }
        $rootScope.$broadcast('userName');
        $rootScope.$broadcast('clearSearchResult');
    });

    $rootScope.$on('enableLogin', function(event, data) {
        menuCtrl.loggedIn = AuthorizeModel.loggedIn;

        // Reset global authorization header
        LoginHelper.setAuthorizationHeader();

        // If SSO is enabled it should not be possible to login again if you logout. In that case the application will have to be restarted.
        if (CONSTANTS.credentialSetting === 'SSO') {
            menuCtrl.showLogin = false;
        }
        $rootScope.$broadcast('userName');
        if (CONSTANTS.credentialSetting === 'SSO') {
            $state.go(CONSTANTS.menu.landingPage);
        }
    });

    $rootScope.$on('disableLogin', function (event, data) {
        menuCtrl.loggedIn = AuthorizeModel.loggedIn;

        // Set global authorization header
        LoginHelper.setAuthorizationHeader();

        $rootScope.$broadcast('stopLoggingIn');
        if (CONSTANTS.credentialSetting === 'BASIC') {
            menuCtrl.showLogin = true;
        }
        $rootScope.$broadcast('clearSearchResult');
        $state.go(CONSTANTS.menu.landingPage);
    });

    $rootScope.$on('noLogin', function (event, data) {
        AuthorizeModel.init();
        menuCtrl.loggedIn = AuthorizeModel.loggedIn;
    });

    $rootScope.$on('$stateChangeSuccess', function(event, toState) {
        menuCtrl.toggleMenu = false;
    });

    menuCtrl.showWebHelp = function () {
        var gAgent = navigator.userAgent.toLowerCase();
        var gbChrome=(gAgent.indexOf("chrome")!=-1);
        var gbSafari=(gAgent.indexOf("safari")!=-1);
        var gbFirefox=(gAgent.indexOf("firefox")!=-1);

        var nMapId = MenuModel.data().helpIndex;
        var strWnd = "";
        var url = CONSTANTS.helpServer;
        var helpLanguages = CONSTANTS.helpLanguages;
        var language =  "/" ;
        var pszHelpFile = "";

        var host = $location.protocol() + "://" + $location.host();
        var port = $location.port();

        if (helpLanguages.indexOf($translate.use()) != -1) {
            language += $translate.use() + "/";
        } else {
            language += "en" + "/";
        }
        if ('80' !== port) {
            host += ":" + port;
        }
        if (!nMapId) {
            nMapId = "";
        }
        if (!gbChrome && gbSafari) {
            pszHelpFile = "#%3Cid=" + nMapId;
        } else {
            pszHelpFile = "#<id=" + nMapId;
        }


        var firstSegment = url.substr(0, url.lastIndexOf('/'));
        var lastSegment = url.substr(url.lastIndexOf('/') + 1);
        pszHelpFile = host + firstSegment + language + lastSegment + pszHelpFile;

        if (gbChrome) {
            var popup  = $window.open("about:blank", "_blank"); // the about:blank is to please Chrome, and _blank to please Firefox
            popup.location = pszHelpFile;
        } else if (gbSafari) {
        	window.open(pszHelpFile);
        } else {
            menuCtrl.loadData(pszHelpFile);
        }

    };

    menuCtrl.loadData = function(sFileName)
    {
        var gAgent = navigator.userAgent.toLowerCase();
        var gbChrome=(gAgent.indexOf("chrome")!=-1);
        var gbSafari=(gAgent.indexOf("safari")!=-1);
        var gbFirefox=(gAgent.indexOf("firefox")!=-1);
        var gbMac=(gAgent.indexOf("mac")!=-1);

        if(!menuCtrl.getElement("dataDiv"))
        {
            if(!menuCtrl.insertDataDiv())
            {

                gsFileName=sFileName;
                return;
            }
        }

        var sHTML="";
        if (gbMac)
            sHTML+="<iframe name=\"__WebHelpCshStub\" src=\""+sFileName+"\"></iframe>";
        else
            sHTML+="<iframe name=\"__WebHelpCshStub\" style=\"visibility:hidden;width:0;height:0\" src=\""+sFileName+"\"></iframe>";


        var oDivCon=menuCtrl.getElement("dataDiv");
        if(oDivCon)
        {
            if (gbChrome || gbSafari) {
                var iframe = menuCtrl.getElement("__chrome");
                if(iframe) {
                    oDivCon.removeChild(iframe);
                }
                iframe=document.createElement("iframe");
                iframe.setAttribute("id", "__chrome");
                iframe.setAttribute("name", "__WebHelpCshStub");
                iframe.setAttribute("src", sFileName);
                if(gbMac)
                    oDivCon.setAttribute("style", "visibility:hidden;width:0;height:0");
                oDivCon.appendChild(iframe);
            } else if (gbFirefox) {
                if (oDivCon.getElementsByTagName&&oDivCon.getElementsByTagName("iFrame").length > 0) {
                    oDivCon.getElementsByTagName("iFrame")[0].src=sFileName;
                } else {
                    oDivCon.innerHTML = sHTML;
                }
        	} else {
                oDivCon.innerHTML=sHTML;
            }
        }
    };

    menuCtrl.getElement = function(sID)
    {

        if (document.getElementById)
            return document.getElementById(sID);
        else if(document.all)
            return document.all(sID);
        return null;
    };

    menuCtrl.insertDataDiv = function()
    {
        var gAgent = navigator.userAgent.toLowerCase();
        var gbChrome=(gAgent.indexOf("chrome")!=-1);
        var gbSafari=(gAgent.indexOf("safari")!=-1);
        var gbFirefox=(gAgent.indexOf("firefox")!=-1);
        var gbMac=(gAgent.indexOf("mac")!=-1);

        var sHTML="";
        if (gbMac) {
            sHTML += "<div id=dataDiv style=\"display:none;\"></div>";
        } else {
            sHTML+="<div id=dataDiv style=\"visibility:hidden\"></div>";
        }
        var obj = document.body;
        if (navigator.userAgent.indexOf('MSIE')!==-1 || navigator.appVersion.indexOf('Trident/') > 0) {
            obj.insertAdjacentHTML("beforeEnd", sHTML);
        } else if (gbFirefox) {
            var r = obj.ownerDocument.createRange();
            r.setStartBefore(obj);
            var	parsedHTML = r.createContextualFragment(sHTML);
            obj.appendChild(parsedHTML);
        } else if (gbChrome || gbSafari){
            var e=document.createElement("div");
            e.setAttribute("id", "dataDiv");
            if (gbMac)
                e.setAttribute("style", "display:none");
            else
                e.setAttribute("style", "visibility:hidden");
            obj.appendChild(e);
        }
        return true;
    };
    // refresh variable after initialize
    menuCtrl.updateMenu();
    MenuModel.registerObserverCallback(menuCtrl.updateMenu);
});

arcticTARIFF.run(function (CommonHelper) {
    // When firstly opening Tariff GUI, we need to set used language to open ite-auth GUI later.
    CommonHelper.setCookie('language', localStorage.getItem('NG_TRANSLATE_LANG_KEY'), 360);
});

arcticTARIFF.run(function (CONSTANTS, LoginHelper) {
    // Avoid error when credentialSetting is 'NONE' and ite-auth module is not deployed.
    if (CONSTANTS.credentialSetting === 'SSO' || CONSTANTS.credentialSetting === 'BASIC') {
        // If reloaded browser try to read JWT from session storage
        LoginHelper.login();
    }
});

arcticTARIFF.run(function ($rootScope, $translate, CommonHelper, tmhDynamicLocale, $window, $state, MenuModel, MetaDataInformationService, CONSTANTS) {
    $rootScope.$on('$translatePartialLoaderStructureChanged', function () {
        $translate.refresh();
    });

    $rootScope.$on('$translateChangeSuccess', function () {
        $rootScope.language = $translate.use();
        $rootScope.logoImagePath = CommonHelper.getLogoImagePath();
        CommonHelper.translateCalendarButtons();
        CommonHelper.setDynamicLocale(tmhDynamicLocale);

        if (!$state.current || !$state.current.name){

            //Do not do anything below
            return;
        }

        changeDocumentTitle($state.current.name);
        MenuModel.notifyObservers();

    });

    $rootScope.$on('$stateChangeSuccess', function(event, toState) {
        changeDocumentTitle(toState.name);
    });

    function changeDocumentTitle(stateName) {
        let defaultPageTitleKey = 'i8n.common.arctic-tariff.title.' + stateName;

        // Browser title
        $translate(defaultPageTitleKey).then(function (defaultPageTitleValue) {
            if (CONSTANTS.branding === 'KGH') {
                // 1. Browser title
                if($rootScope.language === 'en') {
                    $translate('i8n.common.arctic-tariff.title').then(function (pageTitleValue) {
                        $window.document.title = defaultPageTitleValue + pageTitleValue;
                    });
                } else {
                    $window.document.title = defaultPageTitleValue;
                }

                // 2. Homepage text
                $translate('i8n.common.welcome.text').then(function (welcomeTextValue) {
                    if($window.document.getElementById('home-welcomeText')) {
                        $window.document.getElementById('home-welcomeText').innerHTML = welcomeTextValue;
                    }
                });
            } else {
                if ($rootScope.language === 'en') {
                    if (['EE', 'CY', 'SE', 'DK', 'NL'].includes(CONSTANTS.installationCountry)) {
                        // 1. Browser title
                        $translate(`i8n.common.arctic-tariff.title-${CONSTANTS.installationCountry}`).then(function (pageTitleValue) {
                            $window.document.title = defaultPageTitleValue + pageTitleValue;
                        });

                        // 2. Homepage text
                        $translate(`i8n.common.welcome.text${CONSTANTS.installationCountry}`).then(function (welcomeTextValue) {
                            if($window.document.getElementById('home-welcomeText')) {
                                $window.document.getElementById('home-welcomeText').innerHTML = welcomeTextValue;
                            }
                        });
                    } else {
                        // 1. Browser title
                        $translate('i8n.common.arctic-tariff.title').then(function (pageTitleValue) {
                            $window.document.title = defaultPageTitleValue + pageTitleValue;
                        });

                        // 2. Homepage text
                        $translate('i8n.common.welcome.text').then(function (welcomeTextValue) {
                            if($window.document.getElementById('home-welcomeText')) {
                                $window.document.getElementById('home-welcomeText').innerHTML = welcomeTextValue;
                            }
                        });
                    }
                } else {
                    // 1. Browser title
                    $window.document.title = defaultPageTitleValue;

                    // 2. Homepage text
                    $translate('i8n.common.welcome.text').then(function (welcomeTextValue) {
                        if($window.document.getElementById('home-welcomeText')) {
                            $window.document.getElementById('home-welcomeText').innerHTML = welcomeTextValue;
                        }
                    });
                }
            }

            MetaDataInformationService.reloadMetaDataInformation();
        }, function (error) {
        });
    }

    $rootScope.$on('$locationChangeSuccess', function(evt) {

        var mainContent = document.getElementById('mainContent');
        if (mainContent){
            mainContent.focus();
        }

        $window.scrollTo(0, 0);
    });
});

arcticTARIFF.run(function (uibPaginationConfig, uibDatepickerConfig, CONSTANTS, $state) {
    uibPaginationConfig.itemsPerPage = CONSTANTS.rowsPerPage;

    //Open calendar with starting date = Monday
    uibDatepickerConfig.startingDay = 1;
    $state.go(CONSTANTS.menu.landingPage);
});



// WEBPACK FOOTER //
// ./app/js/arctic-tariff.js